import { type GetBalanceCurrencyDTO } from '@capsicum/common';
import { type MainCurrencies } from '@capsicum/socios-core';

import { useNCWSendAmount } from './useNCWSendAmount';

export const useNCWSendTokenAmount = (
	tokenBalanceRaw?: GetBalanceCurrencyDTO,
	currencies?: MainCurrencies,
	hasDecimals?: boolean
) => {
	const { conversionAltPrice, convertedDefaultPrice, error, inputValue, setError, setInputValue } = useNCWSendAmount(
		tokenBalanceRaw,
		currencies,
		hasDecimals
	);

	return {
		conversionAltPrice,
		convertedDefaultPrice,
		error,
		inputValue,
		setError,
		setInputValue
	};
};
